import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';

import { getLocalUserId } from 'src/features/auth';
import { useGetUser } from 'src/features/profile/api/useGetUser';
import ProfileEmailForm from 'src/features/profile/components/ProfileEmailForm';
import ProfileLayout from 'src/features/profile/components/ProfileLayout';
import { emailMessages } from 'src/features/profile/utils';
import GeneralMessageBlock from 'src/registry/components/blocks/GeneralMessageBlock';
import {
    SectionBlock,
    SectionBlockHeader,
    SectionBlockHead,
    SectionBlockTitle,
    SectionBlockSubtitle,
    SectionBlockSeparator,
    SectionBlockBody,
} from 'src/registry/components/blocks/SectionBlock';
import { Skeleton } from 'src/registry/ui/Skeleton';

const Email = () => {
    const { formatMessage } = useIntl();
    const userId = getLocalUserId();
    const { data, isLoading, isError, refetch } = useGetUser({ userId, config: { enabled: !!userId } });

    return (
        <ProfileLayout>
            <SectionBlock>
                <SectionBlockHeader>
                    <SectionBlockHead>
                        <SectionBlockTitle>{formatMessage(emailMessages.emailTitle)}</SectionBlockTitle>
                        <SectionBlockSubtitle>{formatMessage(emailMessages.emailTitleSubtitle)}</SectionBlockSubtitle>
                    </SectionBlockHead>
                </SectionBlockHeader>
                <SectionBlockSeparator />
                <SectionBlockBody>
                    {isLoading && (
                        <div>
                            <Skeleton className="mt-4 h-12 w-full" />
                            <Skeleton className="mt-4 h-12 w-full" />
                            <Skeleton className="mt-4 h-12 w-full" />
                        </div>
                    )}
                    {isError && <GeneralMessageBlock variant="error" icon={faCircleExclamation} />}
                    {data && <ProfileEmailForm userId={userId} data={data} refetch={refetch} />}
                </SectionBlockBody>
            </SectionBlock>
        </ProfileLayout>
    );
};

export default Email;
